(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.register = function(module) {
    return module.service('Core.Services.Map', [exports.Map]);
  };

  exports.Map = (function(superClass) {
    extend(Map, superClass);

    Map.prototype.map = null;

    Map.prototype.L = null;

    Map.prototype.layers = {};

    function Map(L) {
      this.L = L;
      this.getByName = bind(this.getByName, this);
      this.removeByName = bind(this.removeByName, this);
      this.centerOn = bind(this.centerOn, this);
      if (this.L == null) {
        this.L = window.L;
      }
      if (App.map != null) {
        this.map = App.map;
      }
    }

    Map.prototype.createMap = function() {
      return void 0;
    };

    Map.prototype.getLeaflet = function() {
      return this.L;
    };

    Map.prototype.createFeatureGroup = function(layers) {
      if (layers == null) {
        layers = [];
      }
      return this.L.featureGroup(layers);
    };

    Map.prototype.centerOn = function(feature) {
      var bounds;
      if (feature.getBounds != null) {
        bounds = feature.getBounds();
      } else {
        bounds = feature;
      }
      return this.map.fitBounds(bounds);
    };

    Map.prototype.add = function(feature, map, name) {
      if (map == null) {
        map = null;
      }
      if (name == null) {
        name = null;
      }
      if (map == null) {
        map = this.map;
      }
      map.addLayer(feature);
      if (name != null) {
        return this.layers[name] = {
          feature: feature,
          added_to: map
        };
      }
    };

    Map.prototype.remove = function(feature, map) {
      if (map == null) {
        map = null;
      }
      if (map == null) {
        map = this.map;
      }
      return map.removeLayer(feature);
    };

    Map.prototype.removeByName = function(name) {
      if (this.layers[name] != null) {
        this.layers[name].added_to.removeLayer(this.layers[name].feature);
        return delete this.layers[name];
      }
    };

    Map.prototype.getByName = function(name) {
      if (this.layers[name] != null) {
        return this.layers[name];
      }
    };

    return Map;

  })(Service);

}).call(this);
